import { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import { setSiteThemeConfigData } from "../../redux/actions/siteConfigDataActions";
import { getSiteThemeConfigApi } from "../../redux/sagas/requests/commonRequest";
import { AppState } from "../../redux/types";
import { apiRequestHandler, insertSiteConfigRootStyles } from "../../utils/commonFunctions";
import Navbar from "../navbar/Navbar";
import TransparentLoader from "../transparent-loader/TransparentLoader";
import ComponentLoader from "../ui/loader/ComponentLoader";

const Layout = () => {
  const dispatch = useDispatch();
  const userAuth = useSelector((state: AppState) => state.user.authStatus);
  const isLoading = useSelector((state: AppState) => state?.loader?.transparentLoader);
  const siteConfigRootColors = useSelector((state: AppState) => state.siteThemeConfig.colors);

  useEffect(() => {
    // make api call to get site config data
    const getSiteThemeConfigHandler = async () => {
      if (!siteConfigRootColors.primary_default) {
        const response = await apiRequestHandler(getSiteThemeConfigApi, undefined);
        const siteRootColors = response?.data?.color;
        dispatch(setSiteThemeConfigData({
          logo_img: response?.data?.logo?.location,
          colors: {
            primary_default: siteRootColors?.primary_default,
            primary_dark: siteRootColors?.primary_dark,
            primary_medium: siteRootColors?.primary_medium,
            primary_light: siteRootColors?.primary_light,
          }
        }));
        insertSiteConfigRootStyles({
          primary_default: siteRootColors?.primary_default,
          primary_dark: siteRootColors?.primary_dark,
          primary_medium: siteRootColors?.primary_medium,
          primary_light: siteRootColors?.primary_light,
        })
      }
      else {
        insertSiteConfigRootStyles({
          primary_default: siteConfigRootColors?.primary_default,
          primary_dark: siteConfigRootColors?.primary_dark,
          primary_medium: siteConfigRootColors?.primary_medium,
          primary_light: siteConfigRootColors?.primary_light,
        })
      }

    }
    getSiteThemeConfigHandler();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, siteConfigRootColors.primary_default])

  // Check for authentication
  if (!userAuth) {
    return <Navigate to="/auth" />;
  }

  return (
    <>
      <TransparentLoader loading={isLoading} />
      <Navbar />
      <Suspense fallback={<ComponentLoader />} >
        <main
          style={{ marginLeft: "var(--app-sidebar-width, 72px)" }}
          className="transition-[margin-left] duration-300"
        >
          <Outlet />
        </main>
      </Suspense>
    </>
  );
};

export default Layout;
